import { Intervention } from '@agroone/entities'
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core'
import { TranslatePipe, TranslateService } from '@ngx-translate/core'
import { DateWeekNumberDirective } from '../../../../directives/date-week-number.directive'
import { TranslateConstantPipe } from '../../../../pipes'
import { SharedConstantService } from '../../../../services'
import { InterventionFoodSafetyTypes } from '../../enums/intervention-foodsafety-types.enum'

@Component({
  selector: 'pesticide',
  templateUrl: './pesticide.component.html',
  styleUrls: ['./pesticide.component.scss'],
  imports: [TranslateConstantPipe, TranslatePipe, DateWeekNumberDirective],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class PesticideComponent {
  readonly intervention = input.required<Intervention>()
  public constantService: SharedConstantService = inject(SharedConstantService)
  public translate: TranslateService = inject(TranslateService)
  public interventionFoodSafetyTypes = InterventionFoodSafetyTypes
}
